export default __webpack_public_path__ + "static/media/logo-red.bcc0ffd6.svg";